export default "__VITE_ASSET__BGu8jMSn__"